document.addEventListener("DOMContentLoaded", function() {
    // Selecciona todos los elementos <ul> con la clase 'childlist-menu--disclosure'
    var lists = document.querySelectorAll("ul.childlist-menu--disclosure");

    lists.forEach(function(list) {
        var items = list.getElementsByTagName("li");
        var itemCount = items.length;

        // Verifica si hay más de 12 elementos para aplicar dos columnas
        if (itemCount > 12) {
            list.classList.add("two-columns");
        }

        // Verifica si hay más de 24 elementos para ocultar los restantes
        if (itemCount > 24) {
            // Itera sobre los elementos <li> a partir del índice 24 y los oculta
            for (var i = 24; i < itemCount; i++) {
                items[i].style.display = "none";
            }
        }
    });
});
